/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookDeliveryDto } from '../../models/webhook-delivery-dto';

export interface WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Params {
  webhookEndpointId: string;
  page?: number;
  pageSize?: number;
}

export function webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain(http: HttpClient, rootUrl: string, params: WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
  const rb = new RequestBuilder(rootUrl, webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain.PATH, 'get');
  if (params) {
    rb.path('webhookEndpointId', params.webhookEndpointId, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WebhookDeliveryDto>>;
    })
  );
}

webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain.PATH = '/webhooks/monitoring/endpoints/{webhookEndpointId}/deliveries';
